import React from 'react';
import { FaHandPaper } from 'react-icons/fa';

const SocialInteraction: React.FC = () => {
  const handleHighFive = () => {
    if (window.sendMessageToUnity) {
      try {
        const highFiveData = {
          eventType: 'SocialInteraction',
          payload: JSON.stringify({
            interactionType: 'Highfive'
          })
        };
        window.sendMessageToUnity('BrowserBridge', 'ReceivePayload', JSON.stringify(highFiveData));
        console.log('[Browser→Unity] Sent HighFive interaction');
      } catch (error) {
        console.error('[Browser→Unity] Error sending HighFive:', error);
      }
    }
  };

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        handleHighFive();
      }}
      className="px-4 py-2 bg-green-600 bg-opacity-80 text-white rounded-lg hover:bg-opacity-100 transition-all duration-200 font-semibold flex items-center gap-2 shadow-lg"
      title="High Five!"
    >
      <FaHandPaper size={16} />
    </button>
  );
};

export default SocialInteraction;

